import type { ReactElement, ReactNode } from "react";
import { ActionError } from "../../../ActionError/ActionError";
import { ActivityDetailsGroup } from "../../../ActivityDetailsGroup/ActivityDetailsGroup";

interface ActionDetailsContainerProps {
  label: string;
  status: "is_success" | "is_error";
  errorMessage?: string;
  children: ReactNode;
  onDetailsClick?: () => void;
}

/**
 * Common container for action details that handles layout, error display, etc.
 * This component provides a consistent interface for all action result groups
 */
export const ActionDetailsContainer = ({
  label,
  status,
  errorMessage,
  children,
  onDetailsClick,
}: ActionDetailsContainerProps): ReactElement => {
  return (
    <ActivityDetailsGroup
      label={label}
      status={status}
      onClick={onDetailsClick}
    >
      {status === "is_error" && errorMessage && (
        <ActionError errorMessage={errorMessage} />
      )}
      {children}
    </ActivityDetailsGroup>
  );
};
